module.exports = __webpack_public_path__ + "static/img/rentiganying.a32e1610.png";